var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKgaslogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 616,
    height: 351,
    viewBox: "0 0 616 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540.013 159.885L551.607 160.201L330.628 349.609L329.132 351H284.001L121.866 350.557L0 212.231L221.977 31.0412L260.438 0L535.525 0.632205L615.626 104.63L616 105.072H296.53L149.917 224.686L168.555 245.928H289.611L330.441 208.88V159.126H512.087L540.013 159.885Z",
    fill: "url(#paint0_radial_201_88)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_201_88",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(369.185 -359.308 358.815 369.692 51.8518 405)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557561,
    stopColor: "#17C3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBFE87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKgaslogo);
export default __webpack_public_path__ + "static/media/kgaslogo.16aa51096cf022caf6da66d9cda17ed9.svg";
export { ForwardRef as ReactComponent };